/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://dev.dashypay.com/payment-api';
}

/**
 * Parameters for `WabaBotClientApi.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
